import { MainInner } from "@/styles/global";
import { Body, H3, H4, SmallHeading2 } from "@/styles/typography";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Section = styled.div`
  padding: 24px 0 48px !important;
  background-color: #fefbf7;

  scroll-behavior: smooth;
  * {
    scroll-behavior: smooth;
  }
`;

const Inner = styled(MainInner)`
  flex-direction: row;
  justify-content: space-between;
  margin-top: 48px;
  margin-bottom: 16px;

  &:firs-child {
    margin-top: 0;
  }
`;

const NavigationWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const NavigationButton = styled.div<{ $disabled: boolean }>`
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`;

const Title = styled(H3)`
  color: ${({ theme }) => theme.colors.textBlack};
  scroll-margin-top: 130px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    scroll-margin-top: 170px;
  }
`;

const Cards = styled.div`
  overflow: scroll;
  padding: 0px 16px;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 88px;
    scroll-snap-type: x mandatory;
    scroll-padding-left: 8px;
  }

  @media screen and (min-width: 1512px) {
    padding: 0 calc(50vw - 756px + 88px);
  }
`;

const Container = styled.div`
  display: flex;
  gap: 24px;
  width: max-content;
`;

const NewsCard = styled(Link)`
  display: flex;
  background-color: ${({ theme }) => theme.colors.creme};
  border-radius: 14px;
  overflow: hidden;
  text-decoration: none;

  svg {
    transition: transform 0.3s;
  }

  &:hover {
    svg {
      transform: translateX(10px);
    }
  }
`;

const NewsCardImage = styled(GatsbyImage)`
  width: 100%;
  max-width: 207px;
  height: 228px;
  flex-shrink: 0;
`;

const NewsCardTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

const NewsCardDate = styled(Body)`
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
`;

const NewsCardTitle = styled(H4)`
  color: ${({ theme }) => theme.colors.textBlack};
`;

const NewsCardReadMoreWrapper = styled.div`
  display: flex;
  gap: 100px;
  margin-top: auto;
`;

const NewsCardReadMore = styled(SmallHeading2)`
  color: ${({ theme }) => theme.colors.textBlack};
`;

const ScrollContainer = styled.div`
  position: sticky;
  top: 50px;
  z-index: 100;
  background: #fefbf7;
  padding: 16px 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin: 0 auto;
    padding: 24px 88px;
    max-width: 1512px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}) {
    top: 70px;
  }
`;

const Filters = styled.div`
  overflow: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 10;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 50%;
    overflow: unset;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

const Filter = styled.a<{ $active?: boolean }>`
  padding: 8px 0;
  min-width: max-content;
  display: flex;
  text-decoration: none;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  opacity: ${({ $active }) =>
    $active === undefined ? 1 : $active === true ? 1 : 0.5};
  border-bottom: ${({ $active, theme }) =>
    `2px solid ${theme.colors[$active ? "pink" : "transparent"]}`};

  &:first-of-type {
    margin-left: 16px;
  }

  &:last-of-type {
    margin-right: 16px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: max-content;
    transition: all 0.2s ease-in-out;

    opacity: ${({ $active }) =>
      $active == undefined ? 1 : $active == true ? 1 : 0.6};

    &:hover {
      opacity: ${({ $active }) => ($active == undefined ? 0.6 : 1)};
    }

    padding: 0;
    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

const ScrollOffset = styled.div`
  scroll-margin-top: 200px;
`;

const S = {
  Section,
  Inner,
  Title,
  NavigationWrapper,
  NavigationButton,
  Cards,
  Container,
  NewsCard,
  NewsCardTextWrapper,
  NewsCardImage,
  NewsCardTitle,
  NewsCardDate,
  NewsCardReadMoreWrapper,
  NewsCardReadMore,
  ScrollContainer,
  Filters,
  Filter,
  ScrollOffset,
};

export default S;
